<script>
    export let disabled = false;
    export let tooltip = "";
</script>

<sl-tooltip disabled={!disabled} content="{tooltip}" placement="top">
    <button class="button-82-pushable {disabled ? 'disabled' : ''}" role="button" on:click>
        <span class="button-82-shadow"></span>
        <span class="button-82-edge"></span>
        <span class="button-82-front text"><slot></slot></span>
    </button>
</sl-tooltip>

<style>
    .button-82-pushable.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
    }

    .button-82-pushable {
        position: relative;
        border: none;
        background: transparent;
        padding: 0;
        cursor: pointer;
        outline-offset: 4px;
        transition: filter 250ms;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        margin: 0 0.5em;
    }

    .button-82-shadow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background: hsl(0deg 0% 0% / 0.25);
        will-change: transform;
        transform: translateY(2px);
        transition:
                transform
                600ms
                cubic-bezier(.3, .7, .4, 1);
    }

    .button-82-edge {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        background: linear-gradient(
                to left,
                hsl(340deg 100% 16%) 0%,
                hsl(340deg 100% 32%) 8%,
                hsl(340deg 100% 32%) 92%,
                hsl(340deg 100% 16%) 100%
        );
    }

    .button-82-front {
        display: block;
        position: relative;
        padding: 12px 27px;
        border-radius: 12px;
        font-size: 1.1rem;
        color: white;
        background: hsl(345deg 100% 47%);
        will-change: transform;
        transform: translateY(-4px);
        transition:
                transform
                600ms
                cubic-bezier(.3, .7, .4, 1);
    }

    @media (min-width: 768px) {
        .button-82-front {
            font-size: 1.25rem;
            padding: 12px 42px;
        }
    }

    .button-82-pushable:hover:not(.disabled){
        filter: brightness(110%);
    }

    .button-82-pushable:hover:not(.disabled) .button-82-front:not(.disabled){
        transform: translateY(-6px);
        transition:
                transform
                250ms
                cubic-bezier(.3, .7, .4, 1.5);
    }

    .button-82-pushable:active:not(.disabled) .button-82-front:not(.disabled){
        transform: translateY(-2px);
        transition: transform 34ms;
    }

    .button-82-pushable:hover:not(.disabled) .button-82-shadow:not(.disabled){
        transform: translateY(4px);
        transition:
                transform
                250ms
                cubic-bezier(.3, .7, .4, 1.5);
    }

    .button-82-pushable:active:not(.disabled) .button-82-shadow:not(.disabled){
        transform: translateY(1px);
        transition: transform 34ms;
    }

    .button-82-pushable:focus:not(:focus-visible):not(.disabled){
        outline: none;
    }
</style>
